import { formatLabelIntoRevenuePriceTitle } from './currencyUtils/CurrencyUtils';

export const getChartSubtitles = (
  kpiTitle: string,
  shareTypeRef: string,
  currencyLabel: string,
) => {
  const kpiSubtitleStr = formatLabelIntoRevenuePriceTitle(kpiTitle.split(' ')[1], currencyLabel);
  let subTitle = kpiSubtitleStr.includes('Price')
    ? kpiSubtitleStr
    : kpiSubtitleStr.concat(' ', shareTypeRef.charAt(0), shareTypeRef.slice(1).toLowerCase());

  return ['Market '.concat(kpiSubtitleStr), 'Retailer '.concat(subTitle)];
};
